// axiosInstance.js
import axios from 'axios';
import keycloak from './../src/common/Keycloak';
import CryptoJS from 'crypto-js';
import alertifyjs from 'alertifyjs';

// Create an Axios instance with default configurations
const axiosInstance = axios.create({
    baseURL: (process.env.NODE_ENV === 'production') ? 'https://lastmileallocationpod-api.xbees.in/' : 'https://lastmileallocationpod-apistage.xbees.in/',
    responseType: 'json',
    timeout: 20000, // Optional: Set a timeout for requests
});

// Optionally add an interceptor to set headers dynamically
if (keycloak.enableKavach) {
    axiosInstance.interceptors.request.use(
        config => {
            let userToken = window.localStorage.getItem('lmUserToken')
            let token = userToken ? userToken.replace(/"/g, '') : false;
            if (token) {
                config.headers['x-auth-type'] = `lm-kavach-web`; // Set the Authorization header
                config.headers.Authorization = `Bearer ${token}`; // Set the Authorization header

                let userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
                let userDataKey = window.localStorage.getItem('userUniqueKey')
                if (userdetailEncrypt && userDataKey) {
                    let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), userDataKey);
                    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    let userdetail = JSON.parse(plaintext);
                    config.headers['id'] = userdetail.userid;
                    if (userdetail.hubdetails && userdetail.hubdetails[0] != null) {
                        config.headers['x-lmu-meta-01'] = config.headers['x-lmu-meta-01'] = userdetail.hubdetails[0].toString()
                    }
                }
            } else {
                alertifyjs.error('Unauthorized access. Please login again.');
                keycloak.logoutWithTokenId();
            }

            return config;
        },
        error => Promise.reject(error)
    );

    // Add a response interceptor
    axiosInstance.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        let isLoggedIn = window.localStorage.getItem('isLoggedIn');
        if (error && error.response && error.response.status === 401) {
            let errorRes = ((error.response && error.response.data) ? error.response.data : {});
            if (isLoggedIn) {
                alertifyjs.error(errorRes.message);
            }
            window.localStorage.setItem('isLoggedIn', false);
            keycloak.logoutWithTokenId();
        } else {
            return Promise.reject(error);
        }
    });
}

export default axiosInstance;



//////////////////
// WEBPACK FOOTER
// ./services/axiosins.js
// module id = 1219
// module chunks = 1